import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { BagButton } from "@/components/Bag";

export function DelegateConfirmModal({ text, busy, onCancel, onConfirm }) {
  const { user } = useAuth();
  const [amount, setAmount] = useState("");
  const n = Number(amount);
  const affordable = user?.is_god || n <= (user?.provisions || 0);
  const canSubmit = Number.isInteger(n) && n >= 1 && affordable && !busy;
  const fire = () => canSubmit && onConfirm(n);
  const field = { background: "transparent", borderBottom: "1px solid var(--border)", color: "var(--text-primary)" };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-6 fade-in" style={{ background: "rgba(0,0,0,0.7)" }} onClick={onCancel} data-testid="delegate-confirm-overlay">
      <div className="w-full max-w-xl p-8 max-h-[90vh] overflow-y-auto" style={{ background: "var(--bg-modal)", border: "1px solid var(--border)" }} onClick={(e) => e.stopPropagation()} data-testid="delegate-confirm-modal">
        <div className="flex items-center justify-between gap-4">
          <span className="text-xs uppercase tracking-widest" style={{ color: "var(--text-muted)" }}>your delegation</span>
          <BagButton amount={user?.provisions} isGod={user?.is_god} testId="delegate-bag-btn" />
        </div>
        <p className="long-text font-head font-light text-xl mt-4 mb-8 leading-relaxed" style={{ color: "var(--text-primary)" }}>{text}</p>
        <label className="text-xs uppercase tracking-widest" style={{ color: "var(--text-muted)" }}>Reward (provisions)</label>
        <input data-testid="delegate-provisions-input" type="number" min={1} value={amount} onChange={(e) => setAmount(e.target.value.replace(/[^0-9]/g, ""))} onKeyDown={(e) => e.key === "Enter" && fire()} autoFocus placeholder="1" className="w-full py-3 mt-2 text-lg" style={field} />
        {amount && !affordable && <p className="text-xs mt-2" style={{ color: "var(--accent)" }} data-testid="delegate-insufficient">not enough provisions</p>}
        <p className="text-xs mt-2" style={{ color: "var(--text-muted)" }}>held from your bag until a member confirms completion</p>
        <div className="flex gap-4 mt-10">
          <button onClick={onCancel} data-testid="delegate-cancel-btn" className="btn flex-1 py-3 text-sm tracking-widest">CANCEL</button>
          <button onClick={fire} disabled={!canSubmit} data-testid="delegate-confirm-btn" className="btn flex-1 py-3 text-sm tracking-widest">{busy ? "…" : "DELEGATE"}</button>
        </div>
      </div>
    </div>
  );
}
